import React, { useEffect } from 'react';
import { useAsyncValue, useNavigate } from 'react-router-dom';

export default function ActionSummary(): JSX.Element {
  const data = useAsyncValue() as any;
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to validation page
    if (data && data.id) {
      navigate(`/work-orders/validation-actions/summary/${data.id}`, { replace: true });
    }
  }, [data, navigate]);

  return <></>;
}
